import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'wifi-0', 'Wifi0', [["path",{"d":"M12 18l.01 0","key":"svg-0"}]]);